import { siteConfig } from "../siteConfig";

export const FACEBOOK_PIXEL_ID = "1765192557664313";
const FACEBOOK_PIXEL_SCRIPT_ID = "magnify-facebook-pixel";

type FacebookPixel = (action: string, ...args: unknown[]) => void;
type FacebookPixelShim = FacebookPixel & {
  callMethod?: (...args: Parameters<FacebookPixel>) => void;
  loaded: boolean;
  version: string;
  queue: Parameters<FacebookPixel>[];
  push: FacebookPixel;
};

declare global {
  interface Window {
    fbq?: FacebookPixel;
    _fbq?: FacebookPixel;
    __magnifyFacebookPixelInitialized?: boolean;
  }
}

export function loadFacebookPixelScript() {
  if (document.getElementById(FACEBOOK_PIXEL_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = FACEBOOK_PIXEL_SCRIPT_ID;
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
}

export function initializeFacebookPixel() {
  if (window.fbq) return;

  const fbqShim = function (...args: Parameters<FacebookPixel>) {
    if (fbqShim.callMethod) {
      fbqShim.callMethod(...args);
    } else {
      fbqShim.queue.push(args);
    }
  } as FacebookPixelShim;

  window.fbq = fbqShim;
  window._fbq = fbqShim;
  fbqShim.push = fbqShim;
  fbqShim.loaded = true;
  fbqShim.version = "2.0";
  fbqShim.queue = [];
}

export function trackFacebookPixelPageView() {
  if (typeof window.fbq !== "function") return;

  if (!window.__magnifyFacebookPixelInitialized) {
    window.fbq("init", FACEBOOK_PIXEL_ID);
    window.fbq("track", "PageView");
    window.__magnifyFacebookPixelInitialized = true;
    return;
  }

  window.fbq("track", "PageView");
}

export function trackShopifyAppStoreLead() {
  if (typeof window === "undefined" || typeof window.fbq !== "function") {
    return;
  }

  window.fbq("track", "Lead", {
    content_name: "Shopify App Store click",
    destination_url: siteConfig.appStoreUrl,
  });
}
